export default __webpack_public_path__ + "static/2-86736822ff0bc3c82059c51255edca45.jpg";